<template>
  <transition name="modal" v-if="show">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h6>Detail About Word</h6>
            <button @click="$emit('close')" class="btn btn-primary">Close</button>
          </div>

          <div class="modal-body">
            <table class="table">
              <tr>
                <td>Romaji</td>
                <td class="header">{{ data.romaji }}</td>
                <td>Kanji</td>
                <td class="header">{{ data.kanji }}</td>
                <td>Furigana</td>
                <td class="header">{{ data.furigana }}</td>
              </tr>
              <tr>
                <td>Meaning</td>
                <td class="header">{{ data.meaning }}</td>
                <td>Part of Speech</td>
                <td class="header">{{ data.part_of_speech }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>JPL Level</td>
                <td class="header">{{ data.level.name }}</td>
                <td>Book</td>
                <td class="header">{{ data.book.name }}</td>
                <td>Lesson No</td>
                <td class="header">{{ data.lesson_no }}</td>
              </tr>

              <tr>
                <td>Eg Sentence</td>
                <td class="header">{{ data.eg_sentence }}</td>
                <td colspan="4"></td>
              </tr>
              <tr>
                <td>Stroke Link</td>
                <td class="header">{{ data.stroke_link }}</td>
                <td colspan="4"></td>
              </tr>

              <tr>
                <td>Picture</td>
                <td>
                  <a target="_blank" :href="data.full_path">
                    <img :src="data.full_path" style="width:100px;height:100px;" />
                  </a>
                </td>
                <td colspan="4"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ["show", "data"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "@/style/colors.scss";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  height: 700px;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: $primaryColor;
}

.modal-body {
  margin: 20px 0;
}

.modal-header {
  border-bottom: 0.2px solid black;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.header {
  background: $primaryColor;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color:white !important;
}





@media only screen and (max-width: 600px) {
  .modal-container {
  width: 90%;
  margin: 0px auto;
  height: 700px;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
}

</style>
